import { getFacingCount } from '@/lib/utils'
import NoDataText from '@components/shelfDetails/NoDataText'
import useShelfSourceText from '@components/shelfDetails/useShelfSourceText'
import { getShelfColorByUnknownPercentage } from '@components/storeMap/utils'
import useTypedTranslation from '@hooks/useTypedTranslation'

import type { ShelfCategory } from '@components/storeMap/categoryGrouping/util'
import type { MapLayer } from '@components/storeMap/provider/Provider'
import type { Shelf } from '@state/shelf/types'

interface ShelfInfoPopoverContentProps {
  shelf: Shelf
  activeLayers: MapLayer[]
}

function ShelfInfoPopoverContent({ shelf, activeLayers }: ShelfInfoPopoverContentProps) {
  const { t } = useTypedTranslation()
  const sourceText = useShelfSourceText(shelf)

  const isCategoryLayer = activeLayers.includes('CATEGORY_GROUPING') || activeLayers.includes('CATEGORY_GROUPING_DEBUG')

  const unknownProductsShare = shelf.statistics?.shareOfUnknownProducts
  const hasFacings = getFacingCount(shelf) > 0

  return (
    <div className="flex flex-col gap-1 text-xs" data-testid="shelf-info-popover-content">
      <p className="font-semibold text-white">{t('storeMap.infoPopover.shelf')}: {shelf.name}</p>
      {isCategoryLayer && (
        <p className='font-medium text-tooltip-supporting-text'>
          {t('storeMap.infoPopover.category')}: {shelf.statistics?.shelfCategory ? t(`shelfCategories.${shelf.statistics.shelfCategory as ShelfCategory}`) : '-'}
        </p>
      )}

      {activeLayers.includes('HEATMAP_UNKNOWNS') && (
        <p className='font-medium text-tooltip-supporting-text'>
          {t('storeMap.infoPopover.shareUnknown')}: {unknownProductsShare ? <span style={{ color: getShelfColorByUnknownPercentage(unknownProductsShare) }}>{unknownProductsShare}%</span> : '-'}
        </p>
      )}

      {activeLayers.includes('DATA_AGE') && shelf.dayState && sourceText && (
        <p className='font-medium text-tooltip-supporting-text'>{sourceText}</p>
      )}

      {shelf.dayState === 'noData' ? (
        <p className='font-medium text-tooltip-supporting-text'>
          <NoDataText lastObservedAt={shelf.lastObservedAt} />
        </p>
      ) : !hasFacings && (
        <p className='font-medium text-tooltip-supporting-text'>
          {t('storeMap.infoPopover.noFacings')}
        </p>
      )}
    </div>
  )
}

export default ShelfInfoPopoverContent